import React from 'react';
import { ModalProps } from 'antd';
import { ModalContainer } from './styles';

interface CustomModalProps extends ModalProps {
	width: number;
	children: React.ReactNode;
}

export const CustomModal: React.FC<CustomModalProps> = ({ children, width, ...props }) => (
	<ModalContainer width={width} {...props}>
		{children}
	</ModalContainer>
);
